import axios from 'axios';

export class AppService{
    //BASE_URL  = 'https://webapp.sfrcaraibe.fr';   
    //BASE_URL  = 'https://webapp-dev.intranet.local';
    //BASE_URL = 'http://localhost/sfrwebapp';
    //BASE_URL = 'http://dgl.webapp.local/sfrwebapp';
    //API_URL = this.BASE_URL+'/api/';
    APP_VERSION ='0.8.5';
    CLIENT_ID ='webapp.sfrcaraibe';
    CLIENT_API_KEY='yr7omPrgXfIjVggbBvGXK+YV6cJg3XoWxBjphJe30GOvZOrokiySw2YSHxg5T+33';
    
    constructor(){
        
        //const API_URL = 'http://localhost/sfrwebapp/api/'
    }
    /*getApiUrl(){
        var apiUrl = '';
        //console.log(document.location);
        if(['localhost:10707','krk-dev:10707'].includes(document.location.host) )
            apiUrl = document.location.protocol+'//'+ document.location.host+'/api/';
        else if(['dgl.webapp.local','localhost'].includes(document.location.hostname) )
            apiUrl = document.location.protocol+'//'+ document.location.hostname+'/sfrwebapp/api/';
        else
            apiUrl = document.location.protocol+'//'+ document.location.hostname+'/api/';
        //console.log(apiUrl);
        return apiUrl;
    }*/

    getApiUrl(){
        var apiUrl = this.getBaseUrl() +'/api/';
        
        return apiUrl;
    }

    getBaseUrl(){
         var baseUrl = '';
        if(['localhost:10707','krk-dev:10707'].includes(document.location.host) )
            baseUrl = document.location.protocol+'//'+ document.location.host;
        else if(['localhost:3000'].includes(document.location.host) )
            baseUrl = document.location.protocol+'//localhost/cgrwebapp.api/src';
        else if(['dgl.webapp.local','localhost'].includes(document.location.hostname) )
            baseUrl = document.location.protocol+'//'+ document.location.hostname+'/cgrwebapp.api/src';
        else
            baseUrl = document.location.protocol+'//'+ document.location.hostname;
        
        return baseUrl;
    }

    getTokenUser(){
        if(sessionStorage.getItem('user')){
            let user = JSON.parse(sessionStorage.getItem('user'));
            if(user && user.token)
                return user.token;
            else
                return null
        }else
           return null;
    }

    get(url,params=null,timeout=null) {
        let tokenUser  = this.getTokenUser();
        
        if(params != null){
            params.params.app_version= this.APP_VERSION;
            
            if(tokenUser){
                params.params.tokenUser= tokenUser;
            }
        }else{
            if(tokenUser){
                params.params = {app_version:this.APP_VERSION,tokenUser:tokenUser};
            }else{
                params.params = {app_version:this.APP_VERSION};
            }
        }

       if(timeout != null)
            params.timeout = timeout;
        
        return axios.get(url,params);
    }

    post(url,params=null) {
        let tokenUser  = this.getTokenUser();
        
        if(params != null){
            params.params.app_version= this.APP_VERSION;
            
            if(tokenUser){
                params.params.tokenUser= tokenUser;
            }
        }else{
            if(tokenUser){
                params.params = {app_version:this.APP_VERSION,tokenUser:tokenUser};
            }else{
                params.params = {app_version:this.APP_VERSION};
            }
        }

        let _data = JSON.stringify(params.params);
        return axios.post(url,_data);
    }

    put(url,params=null) {
        return axios.put(url,params);
    }

    delete(url,params=null) {
        return axios.delete(url,params);
    }

}